/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'office-ui-fabric-react';
import { FocusZone, FocusZoneDirection } from 'office-ui-fabric-react/lib/FocusZone';
import { List } from 'office-ui-fabric-react/lib/List';
import { Persona, PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import styles from './AdvanceGroupActivityItems.style';
import { can } from '../../utils/auth';

const AdvanceGroupAction = ({ action }) => {
  const { newData } = action;
  const initiatedName = can('viewActivityInitiatedBy')
    ? action?.initiatedBy?.name || action?.initiatedBy
    : 'Microsoft';

  const advanceGroupName = newData.name || 'the advance group';

  switch (action.operation) {
    case 'created': {
      return (
        <Text className={styles.itemName}>
          <Text>{initiatedName}</Text>
          <Text className={styles.fontWeightNormal}> created </Text>
          <Text>{advanceGroupName}</Text>
        </Text>
      );
    }

    case 'edited': {
      return (
        <Text className={styles.itemName}>
          <Text>{initiatedName}</Text>
          <Text className={styles.fontWeightNormal}> saved edits to </Text>
          <Text>{advanceGroupName}</Text>
        </Text>
      );
    }

    default:
      return null;
  }
};

const ActivityItem = item => {
  return (
    <div className={styles.activityItem} data-is-focusable>
      <Persona
        imageUrl={can('viewActivityInitiatedBy') ? '' : '/images/msft-avatar.png'}
        size={PersonaSize.size28}
        className={styles.personaCoin}
        hidePersonaDetails
      />

      <div className={styles.itemContent}>
        <AdvanceGroupAction action={item} />
      </div>
      <Text as="p" variant="small" className={styles.date}>
        {item.timestamp && new Date(item.timestamp).toDateString().split(' ').slice(1).join(' ')}
      </Text>
    </div>
  );
};

const AdvanceGroupActivityItems = ({ items }) => (
  <FocusZone direction={FocusZoneDirection.vertical}>
    <List items={items} onRenderCell={ActivityItem} />
  </FocusZone>
);

AdvanceGroupActivityItems.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      timestamp: PropTypes.string.isRequired,
      _id: PropTypes.string.isRequired,
      initiatedBy: PropTypes.shape({
        name: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
      }),
      operation: PropTypes.string.isRequired,
      area: PropTypes.string.isRequired,
      newData: PropTypes.object,
      oldData: PropTypes.object,
    }),
  ),
};

AdvanceGroupActivityItems.defaultProps = {
  items: [],
};

export default AdvanceGroupActivityItems;
